// extracted by mini-css-extract-plugin
export default {"topicAccordion":"AccordionCustom_topicAccordion__1Yzd6"};